module.exports = __webpack_public_path__ + "img/444@2x.b407d8bb.png";